import { TimeButtonProps } from '../buttons.types';
import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { SHORT_DATE_TIME_FORMAT } from 'utils/constants';
import { Icons } from 'greener-ui-library';

function getButtonText(
  range: { from?: Date | number; to?: Date | number } = {},
  selectedOption?: { value: number; label: string },
  rangeFormatter = SHORT_DATE_TIME_FORMAT
): string {
  if (selectedOption) {
    return selectedOption.label;
  }

  return !!range.from && !!range.to
    ? `${format(range.from, rangeFormatter)} - ${format(range.to, rangeFormatter)}`
    : 'Invalid Date Range';
}

export function TimeButton({
  range,
  size,
  selectedOption,
  rangeFormatter,
  endIcon,
  ...rest
}: TimeButtonProps) {
  const { isMobile } = useBreakpoint();
  return (
    <Button
      color="tertiary"
      size={size}
      variant="outlined"
      disableRipple
      {...rest}
      sx={{
        ':hover': { background: 'transparent' },
        paddingX: 1.5,
        textTransform: 'none',
        color: 'text.primary',
        justifyContent: 'space-between',
        width: isMobile ? '100%' : 'auto',
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
        <Icons.AccessTime sx={{ ml: 0.5, mr: 1 }} />
        <Typography noWrap sx={{ minWidth: 0 }}>
          {getButtonText(range, selectedOption, rangeFormatter)}
        </Typography>
      </span>
      {endIcon}
    </Button>
  );
}
